import { useState } from "react";
import React from "react";
import { useThrottleFn, useSetState } from "ahooks";
import apiClient from "@/api/apiClient";
const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [state, setState] = useSetState(initialState);
  const [disabled, setDisabled] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ [name]: value });
  };
  const clearState = () => {
    setState({ ...initialState });
  };
  const { run } = useThrottleFn(
    (e) => {
      console.log(e);
      setDisabled(true);
      e.preventDefault();
      console.log(state.name, state.email, state.message);
      apiClient
        .post("/hailuo/api/out/system/sendMail", {
          subject: state.name,
          to: state.email,
          content: state.message,
        })
        .then((response) => {
          console.log("response", response);
          alert("发送成功");

          clearState();
          // if (0 === response.code) {
          //   alert("发送成功");

          //   clearState();
          // }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          alert("发送失败，请稍后再试");
        })
        .finally(() => {
          setDisabled(false);
          // alert("发送成功");

          // clearState();
        });
    },
    { wait: 500 }
  );

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>联系方式</h2>
                <p>请填写下面的表格发送电子邮件给我们，我们会尽快给您回复。</p>
              </div>
              <form name="sentMessage" validate onSubmit={run}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="名称"
                        required
                        value={state.name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={state.email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="留言"
                    required
                    value={state.message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button disabled={disabled} className="btn btn-custom btn-lg">
                  发送信息
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>联系方式</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> 地址
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> 电话
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item ">
              <p>
                {props.data && props.data.email ? (
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                    <a
                      href={`mailto:${props.data.email}`}
                      style={{ color: "rgb(255 255 255 / 75%)" }}
                    >
                      <span></span> {props.data.email}
                    </a>
                  </span>
                ) : (
                  <>
                    <span>
                      <i className="fa fa-envelope-o "></i> Email
                    </span>{" "}
                    loading
                  </>
                )}
              </p>
            </div>
          </div>
          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025{" "}
            <span class="sc-4494e30-7 gnOYcR">
              广州润钢软件科技有限公司 |{" "}
              <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">
                粤ICP备2025410766号
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
